import { getType } from "../../helpers/getType";

import { getAllowedWorkspacesForSentryLogging } from "./getAllowedWorkspacesForSentryLogging";
import { SentryService } from "./SentryService";
import { SentryLogForAllowedWorkspacesParams } from "./sentryLogForAllowedWorkspaces.types";

export const sentryLogForAllowedWorkspaces = ({
  accountSlug,
  security,
  users,
  teams,
  editable,
  applicationId,
  recordId,
  fieldSlug,
  memberName,
  accessToken,
  env,
  webSocketURL,
  filestackAPIKey,
  platform,
  preset,
}: SentryLogForAllowedWorkspacesParams): void => {
  if (!accountSlug) {
    return;
  }

  const allowedWorkspaces = getAllowedWorkspacesForSentryLogging();

  if (!allowedWorkspaces.includes(accountSlug)) {
    return;
  }

  SentryService.captureException({
    error: new Error("Log: WebView data"),
    data: {
      isSecurityPolicyExist: !!security.policy,
      isSecuritySignatureExist: !!security.signature,
      isAccessTokenExist: !!accessToken,
      isFilestackAPIKeyExist: !!filestackAPIKey,
      usersType: getType(users),
      teamsType: getType(teams),
      editable,
      accountSlug,
      applicationId,
      recordId,
      fieldSlug,
      memberName,
      env,
      webSocketURL,
      platform,
      preset,
    },
    level: "log",
  });
};
